"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSchema = void 0;
var strSchema = {
    type: 'string'
};
var ctxSchema = {
    type: 'object',
    required: ['requestId', 'userId'],
    properties: {
        requestId: { type: 'string' },
        userId: { type: 'string' }
    }
};
var numberSchema = {
    type: ['number', 'null', 'undefined']
};
var strOrNullSchema = {
    type: ['string', 'null', 'undefined']
};
var boolOrNullSchema = {
    type: ['boolean', 'null', 'undefined']
};
var numberOrArraySchema = {
    type: ['number', 'array', 'null', 'undefined']
};
var objectOrNullSchema = {
    type: ['object', 'null']
};
var dateOrNullSchema = {
    type: ['string', 'null', 'undefined']
};
var arrayOrNullSchema = {
    type: ['array', 'null']
};
var productKeySchema = {
    type: 'object',
    required: ['productType', 'productCode', 'state'],
    properties: {
        productType: strSchema,
        productCode: strSchema,
        state: strSchema
    }
};
var benefitKeySchema = {
    type: 'object',
    required: ['benefitCode', 'productType', 'productCode', 'state'],
    properties: {
        benefitCode: strSchema,
        productType: strSchema,
        productCode: strSchema,
        state: strSchema
    }
};
var periodSchema = {
    type: 'object',
    required: ['period', 'statementPeriod'],
    properties: {
        period: numberSchema,
        statementPeriod: numberSchema,
        directBillExtension: numberSchema
    }
};
var categoryVersionSchema = {
    type: 'object',
    required: ['categoryName', 'version'],
    properties: {
        category: strSchema,
        version: strSchema,
        effectiveDate: dateOrNullSchema
    }
};
var categoryVersionRequestSchema = {
    type: 'object',
    required: ['categoryName'],
    properties: {
        category: strSchema,
        asOfDate: dateOrNullSchema
    }
};
var policyForGuaranteedCashValueSchema = {
    type: 'object',
    required: ['asOfDate', 'segments', 'product', 'gender', 'dob'],
    properties: {
        asOfDate: objectOrNullSchema,
        segments: arrayOrNullSchema,
        product: strSchema,
        gender: strSchema,
        dob: objectOrNullSchema
    }
};
var policyForPremiumBreakdownSchema = {
    type: 'object',
    required: ['gender', 'segments', 'duration', 'insuranceAge', 'productVersion', 'totalUnitsPerBenefit', 'isFullRates'],
    properties: {
        gender: strSchema,
        segments: arrayOrNullSchema,
        duration: numberSchema,
        insuranceAge: numberSchema,
        productVersion: strSchema,
        totalUnitsPerBenefit: arrayOrNullSchema,
        isFullRates: boolOrNullSchema
    }
};
var paymentFrequencyEnum = {
    type: ['string'],
    enum: ['Monthly', 'Annual'],
};
var ProductSchema = /** @class */ (function () {
    function ProductSchema() {
    }
    ProductSchema.requestSchemas = {
        GetFreeLookPeriodRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['productKey', 'productVersion', 'insuredAge'],
                    properties: {
                        productKey: productKeySchema,
                        productVersion: strSchema,
                        insuredAge: numberSchema,
                        ownerAge: numberSchema
                    }
                }
            }
        },
        GetFirstPaymentRescissionPeriodRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['productKey', 'productVersion'],
                    properties: {
                        productKey: productKeySchema,
                        productVersion: strSchema
                    }
                }
            }
        },
        GetGracePeriodRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['productKey', 'productVersion'],
                    properties: {
                        productKey: productKeySchema,
                        productVersion: strSchema
                    }
                }
            }
        },
        GetProductAddressRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['productKey', 'productVersion'],
                    properties: {
                        productKey: productKeySchema,
                        productVersion: strSchema
                    }
                }
            }
        },
        GetBenefitAnnualRateRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['benefitKey', 'benefitVersion', 'rateVersion', 'gender', 'isSmoker', 'rateClass', 'units', 'totalUnits',
                        'duration', 'insuranceAge', 'currentOrGuaranteed', 'isFullRates', 'productVersion'],
                    properties: {
                        benefitKey: benefitKeySchema,
                        benefitVersion: strOrNullSchema,
                        rateVersion: strOrNullSchema,
                        gender: strOrNullSchema,
                        isSmoker: boolOrNullSchema,
                        rateClass: strOrNullSchema,
                        units: numberSchema,
                        totalUnits: numberSchema,
                        duration: numberSchema,
                        insuranceAge: numberSchema,
                        currentOrGuaranteed: strSchema,
                        isFullRates: boolOrNullSchema,
                        productVersion: strOrNullSchema
                    }
                }
            }
        },
        GetBenefitAnnualFeeRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['benefitKey', 'rateVersion'],
                    properties: {
                        benefitKey: benefitKeySchema,
                        rateVersion: strOrNullSchema
                    }
                }
            }
        },
        GetProductSpecificationRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['productKey', 'productVersion'],
                    properties: {
                        productKey: productKeySchema,
                        productVersion: strSchema,
                        insuredAge: numberSchema
                    }
                }
            }
        },
        GetBenefitUnitAmountRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['benefitKey', 'engineVersion'],
                    properties: {
                        benefitKey: benefitKeySchema,
                        engineVersion: strSchema
                    }
                }
            }
        },
        GetBenefitEndAgeRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['benefitKey', 'benefitVersion'],
                    properties: {
                        benefitKey: benefitKeySchema,
                        benefitVersion: strSchema
                    }
                }
            }
        },
        GetProrationFactorRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['monthsRemaining'],
                    properties: {
                        monthsRemaining: numberSchema
                    }
                }
            }
        },
        GetSpecificationRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['productKey', 'productVersion'],
                    properties: {
                        productKey: {
                            type: 'object',
                            required: ['productType', 'productCode', 'state'],
                            properties: {
                                productType: strSchema,
                                productCode: strSchema,
                                state: strSchema
                            }
                        },
                        productVersion: strSchema,
                        ownerAge: numberSchema,
                        insuredAge: numberSchema
                    }
                }
            }
        },
        GetLatestVersionRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['categories'],
                    properties: {
                        categoryNames: {
                            type: 'array',
                            items: categoryVersionRequestSchema
                        }
                    }
                }
            }
        },
        GetGuaranteedCashValueRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['policy'],
                    properties: {
                        policy: policyForGuaranteedCashValueSchema
                    }
                }
            }
        },
        GetUnearnedPremiumRatioRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['previousPaidToDate', 'todaysDate', 'paidToDate', 'billedModalPremium'],
                    properties: {
                        previousPaidToDate: objectOrNullSchema,
                        todaysDate: objectOrNullSchema,
                        paidToDate: objectOrNullSchema,
                        billedModalPremium: numberSchema
                    }
                }
            }
        },
        GetTotalPremiumRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['modalFactor', 'policy'],
                    properties: {
                        modalFactor: numberSchema,
                        policy: policyForPremiumBreakdownSchema
                    }
                }
            }
        },
        GetPremiumBreakdownRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['policy'],
                    properties: {
                        policy: policyForPremiumBreakdownSchema
                    }
                }
            }
        },
        GetProductVersionTreeListSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['category'],
                    properties: {
                        category: strSchema
                    }
                }
            }
        },
        GetDiscountRateRequestSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['productKey', 'asOfDate'],
                    properties: {
                        productKey: productKeySchema,
                        asOfDate: objectOrNullSchema
                    }
                }
            }
        }
        //TODO: request schema for calc-e 3 APIs
    };
    ProductSchema.responseSchemas = {
        GetBenefitAnnualFeeResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['fee'],
                    properties: {
                        fee: numberSchema
                    }
                }
            }
        },
        GetBenefitAnnualRateResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['rate'],
                    properties: {
                        rate: numberOrArraySchema
                    }
                }
            }
        },
        GetBenefitAnnualTableRateResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['tableRate'],
                    properties: {
                        tableRate: numberOrArraySchema
                    }
                }
            }
        },
        GetFreeLookPeriodResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['freeLookPeriod'],
                    properties: {
                        freeLookPeriod: periodSchema
                    }
                }
            }
        },
        GetFirstPaymentRescissionPeriodResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['firstPaymentRescissionPeriod'],
                    properties: {
                        firstPaymentRescissionPeriod: periodSchema
                    }
                }
            }
        },
        GetGracePeriodResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['gracePeriod'],
                    properties: {
                        gracePeriod: periodSchema
                    }
                }
            }
        },
        GetProductAddressResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['address'],
                    properties: {
                        address: {
                            type: 'object',
                            required: ['addressName', 'addressLine1', 'addressCity', 'addressState', 'addressZipcode'],
                            properties: {
                                addressName: strSchema,
                                addressLine1: strSchema,
                                addressCity: strSchema,
                                addressState: strSchema,
                                addressZipcode: strSchema
                            }
                        }
                    }
                }
            }
        },
        GetBenefitUnitAmountResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['unitAmount'],
                    properties: {
                        unitAmount: numberSchema
                    }
                }
            }
        },
        GetProductSpecificationResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['channel', 'faceValueMin', 'faceValueMax', 'flatExtraEndAge', 'flatExtraMaxYears'],
                    properties: {
                        channel: strOrNullSchema,
                        faceValueMin: numberSchema,
                        faceValueMax: numberSchema,
                        flatExtraEndAge: numberSchema,
                        flatExtraMaxYears: numberSchema,
                        mecPayPeriod: numberSchema,
                        variableLoanInterestRate: numberSchema,
                        fixedLoanInterestRate: numberSchema
                    }
                }
            }
        },
        GetBenefitEndAgeResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['endAge'],
                    properties: {
                        endAge: numberSchema
                    }
                }
            }
        },
        GetProrationFactorResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['prorationFactor'],
                    properties: {
                        prorationFactor: numberSchema
                    }
                }
            }
        },
        GetSpecificationResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['channel', 'faceValueMin', 'faceValueMax', 'faceValueIncreaseMin', 'faceValueDecreaseMin', 'flatExtraEndAge', 'flatExtraMaxYears'],
                    properties: {
                        channel: strOrNullSchema,
                        faceValueMin: numberSchema,
                        faceValueMax: numberSchema,
                        faceValueIncreaseMin: numberSchema,
                        faceValueDecreaseMin: numberSchema,
                        flatExtraEndAge: numberSchema,
                        flatExtraMaxYears: numberSchema,
                        mecPayPeriod: numberSchema,
                        variableLoanInterestRate: numberSchema,
                        fixedLoanInterestRate: numberSchema
                    }
                }
            }
        },
        GetLatestVersionResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['categoryVersions'],
                    properties: {
                        categoryVersions: {
                            type: 'array',
                            items: categoryVersionSchema
                        }
                    }
                }
            }
        },
        GetTotalPremiumResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['totalPremium'],
                    properties: {
                        totalPremium: numberSchema
                    }
                }
            }
        },
        GetPremiumBreakdownResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['premiumBreakdownResults'],
                    properties: {
                        premiumBreakdownResults: objectOrNullSchema
                    }
                }
            }
        },
        GetGuaranteedCashValueResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['guaranteedCashValue'],
                    properties: {
                        guaranteedCashValue: numberSchema
                    }
                }
            }
        },
        GetUnearnedPremiumRatioResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['ratio'],
                    properties: {
                        ratio: numberSchema
                    }
                }
            }
        },
        GetProductVersionTreeListSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['product_engine']
                }
            }
        },
        GetDiscountRateResponseSchema: {
            type: 'object',
            required: ['context', 'payload'],
            properties: {
                context: ctxSchema,
                payload: {
                    type: 'object',
                    required: ['discountRate'],
                    properties: {
                        discountRate: numberSchema
                    }
                }
            }
        },
    };
    return ProductSchema;
}());
exports.ProductSchema = ProductSchema;
